import React, { useState } from 'react';

interface DetailsStepProps {
  onNext: (data: { name: string; description: string }) => void;
  onBack: () => void;
  onCancel: () => void;
}

const DetailsStep: React.FC<DetailsStepProps> = ({ onNext, onBack, onCancel }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [errors, setErrors] = useState<Record<string, string>>({});

  const validate = (): boolean => {
    const newErrors: Record<string, string> = {};

    if (!name.trim()) {
      newErrors.name = 'Tenant name is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validate()) {
      onNext({
        name: name.trim(),
        description: description.trim(),
      });
    }
  };

  return (
    <div className="card shadow">
      <div className="card-body">
        <div className="welcome-screen">
          <h2>MPX Tenant Details</h2>
          <p>
            Provide a name and optional description for this MPX tenant connection.
          </p>

          <form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
            <div className="mb-4">
              <label htmlFor="name" className="form-label">
                <strong>Tenant Name *</strong>
              </label>
              <input
                type="text"
                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="e.g., Production MPX"
                autoFocus
              />
              {errors.name && (
                <div className="invalid-feedback">{errors.name}</div>
              )}
              <small className="form-text text-muted">
                A descriptive name for this MPX tenant connection
              </small>
            </div>

            <div className="mb-4">
              <label htmlFor="description" className="form-label">
                <strong>Description</strong>
              </label>
              <input
                className="form-control"
                id="description"                
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Optional description of this MPX tenant..."
              />
            </div>

            <div className="d-flex justify-content-between mt-4">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onBack}
              >
                <i className="fas fa-arrow-left mr-2"></i>
                Back
              </button>
              <div>
                <button
                  type="button"
                  className="btn btn-outline-secondary mr-2"
                  onClick={onCancel}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                >
                  Next <i className="fas fa-arrow-right ml-2"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DetailsStep;
